
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bang-gia/kim-cuong/trang/[page]",
      function () {
        return require("private-next-pages/bang-gia/kim-cuong/trang/[page]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bang-gia/kim-cuong/trang/[page]"])
      });
    }
  